import BasicProduction from "@/views/open_queries/customer/BasicProduction.vue";

export default [
  {
    path: "/oq/customer/basic_production/:customer_id/:crop_id",
    name: "oq_customer_basic_production_path",
    component: BasicProduction,
    props: true,
  },
];
